<!-- 生成时间:2022-04-12 09:35:42 -->

<template>
    <div class="app-container">
        <generate-form
            ref="qform"
            v-if="queryParams_formConfig"
            :conf="queryParams_formConfig"
        />

        <el-form ref="queryForm" :inline="true" label-width="68px">
            <el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="mini"
                    @click="handleQuery"
                    >搜索</el-button
                >
                <el-button
                    icon="el-icon-refresh"
                    size="mini"
                    @click="resetQuery"
                    >重置</el-button
                >
            </el-form-item>
        </el-form>

        <jf-import
            :show.sync="importOpen"
            v-if="importOpen"
            :type="2"
            :columns="tableColumn"
            :isfinish="false"
            :downloadtplurl="''"
            :exportTotal="total"
            @exportSubmit="exportSubmit"
        ></jf-import>

        <vxe-grid
            resizable
            ref="xGrid"
            stripe
            show-overflow
            highlight-hover-row
            :loading="loading"
            :toolbar-config="tableToolbar"
            :columns="tableColumn"
            :data="dataList"
            @checkbox-change="checkboxChangeEvent"
            @checkbox-all="checkboxChangeEvent"
        >
            <template #toolbar_buttons>
                <!-- <el-button
          type="info"
          style="margin-left: 10px"
          icon="el-icon-upload"
          size="mini"
          @click="openImportTable"
          v-hasPermi="['bpm:table:add']"
          >导入</el-button
        > -->

                <el-button
                    type="success"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd()"
                    v-if="isShowAdd"
                    >发起</el-button
                >

                <el-button
                    class="btn-orange"
                    size="mini"
                    @click="handleexport()"
                >
                    <i class="iconfont icon-daochu_o"></i>
                    导出
                </el-button>

                <el-button
                    style="margin-left: 10px"
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    @click="handleDelete"
                    v-hasPermi="['/bpm/process/del']"
                    >作废</el-button
                >

                <el-button
                    v-for="item in toolbtninfo[flowid]"
                    :key="item.name"
                    type="success"
                    icon="el-icon-info"
                    size="mini"
                    @click="handleToolBtnAction(item)"
                    >{{ item.label }}</el-button
                >
            </template>

            <!--默认操作按钮-->
            <template #defaultopr="{ row }">
                <el-button
                    v-for="(item, index) in rowbtninfo[flowid]"
                    :key="index"
                    size="mini"
                    type="text"
                    icon="el-icon-info"
                    @click="handleBtnAction(item, row)"
                    >{{ item.label }}
                </el-button>

                <el-button
                    type="text"
                    v-if="row.process_status == '1'"
                    size="mini"
                    icon="el-icon-video-play"
                    @click.stop="handleTodo(row)"
                    >办理</el-button
                >

                <el-button
                    type="text"
                    size="mini"
                    icon="el-icon-view"
                    @click.stop="handleView(row)"
                    >查看</el-button
                >
            </template>
            <template #flowstatus="{ row }">
                <el-tag
                    v-for="dict in statusOptions"
                    :key="dict.key"
                    :type="dict.type"
                    v-if="dict.key == row.process_status"
                    >{{ dict.value }}</el-tag
                >
            </template>
            <template #turn_no="{ row }">
                <el-tag
                    v-for="turn in turn_list"
                    :key="turn.no"
                    v-if="turn.no == row.turn_no"
                    >{{ turn.name }}</el-tag
                >
            </template>

            <template #html="{ row }">
                <div class="" v-html="row.v_d"></div>
            </template>
            <!--自定义空数据模板-->
            <template #empty>
                <span>
                    <p>暂无数据</p>
                </span>
            </template>
        </vxe-grid>

        <vxe-pager
            background
            size="small"
            :loading="loading"
            :current-page="queryParams.pageNum"
            :page-size="queryParams.pageSize"
            :total="total"
            @page-change="handleSizeChange"
        >
        </vxe-pager>

        <!-- 添加或修改对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :title="title"
            :visible.sync="open"
            width="800px"
            append-to-body
        >
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="表名称" prop="table_name">
                    <el-input
                        v-model="form.table_name"
                        placeholder="请输入表名称"
                        disabled="true"
                    />
                </el-form-item>
                <el-form-item label="表描述" prop="table_comment">
                    <el-input
                        v-model="form.table_comment"
                        placeholder="请输入表描述"
                        disabled="true"
                    />
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="form.remark" placeholder="请输入备注" />
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">返 回</el-button>
            </div>
        </el-dialog>

        <!--高级查询对话框-->
        <el-dialog
            title="高级查询"
            :visible.sync="advqueryopen"
            width="1300px"
            append-to-body
        >
            <el-row :gutter="20">
                <el-col :span="15" :xs="24">
                    <vxe-grid
                        border
                        resizable
                        keep-source
                        ref="xAdvqueryGrid"
                        id="id_xAdvqueryGrid"
                        height="500"
                        :columns="advqueryColumn"
                        :toolbar-config="advqueryToolbar"
                        :data="advqueryData"
                        :custom-config="{ storage: true }"
                        :edit-config="{
                            trigger: 'click',
                            mode: 'row',
                            showStatus: true,
                        }"
                        @toolbar-button-click="advqtoolbarButtonClickEvent"
                    >
                        <!-- <template #defaultadvqueryopr=" "> </template> -->
                    </vxe-grid>
                </el-col>
                <el-col :span="9" :xs="24">
                    <vxe-grid
                        border
                        resizable
                        keep-source
                        ref="xAdvqueryGrid_tempfilter"
                        id="id_xAdvqueryGrid_tempfilter"
                        height="500"
                        :columns="advqueryColumn_tempfilter"
                        :data="advqueryData_tempfilter"
                    >
                        <template #defaultadvqueryopr_tempfilter="{ row }">
                            <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-delete"
                                @click="handleadvqueryApplytpl(row)"
                                >应用
                            </el-button>

                            <el-button
                                size="mini"
                                type="text"
                                icon="el-icon-delete"
                                @click="handleadvqueryDeltpl(row)"
                                >删除
                            </el-button>
                        </template>
                    </vxe-grid>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="advquery_save"
                    >确 定</el-button
                >
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>

        <!--保存模版-->
        <el-dialog
            :close-on-click-modal="false"
            title="保存模版"
            :visible.sync="advquery_tempsave"
            width="800px"
            append-to-body
        >
            <el-form
                ref="advquery_tempsaveform"
                :model="advquery_tempsaveform"
                :rules="advquery_tempsaverules"
                label-width="80px"
            >
                <el-form-item label="模版名称" prop="tempname">
                    <el-input
                        v-model="advquery_tempsaveform.tempname"
                        placeholder="请输入模版名称"
                    />
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="advquery_save"
                    >确 定</el-button
                >
            </div>
        </el-dialog>

        <!--导出数据-->
        <el-dialog
            :close-on-click-modal="false"
            title="导出数据"
            :visible.sync="exportdialog"
            width="800px"
            append-to-body
        >
            <el-checkbox
                :indeterminate="exportisIndeterminate"
                v-model="exportcheckAll"
                @change="handleexportCheckAllChange"
                >全选</el-checkbox
            >
            <div style="margin: 15px 0"></div>

            <el-checkbox-group v-model="exportfields">
                <el-checkbox
                    v-for="field in tableColumn"
                    v-if="field.field"
                    :label="field.field"
                    :key="field.field"
                    >{{ field.title }}</el-checkbox
                >
            </el-checkbox-group>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="doExport">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogVisible"> </el-dialog>

        <el-dialog title="查看二维码" :visible.sync="viewqrcodeinfourl">
            <img :src="viewqrcodeinfourl" />
        </el-dialog>

        <el-dialog title="发起" :visible.sync="showtask" width="1200px">
            <BmpTask
                ref="BmpTask"
                :propsflowid="flowid"
                startfrom=""
                @startsuccess="startsuccess"
            ></BmpTask>
        </el-dialog>

        <el-dialog
            :title="formdatamodeltitle"
            :visible.sync="showformdatamodel"
            :width="'1200px'"
            :close-on-click-modal="false"
            append-to-body
            :before-close="
                () => {
                    showformdatamodel = false;
                }
            "
            custom-class="scrolldialog"
        >
            <FormDataModel
                v-if="showformdatamodel"
                ref="FormDataModel"
                :propsmid="propsMid"
                :propsqueryparam="propsqueryparam"
                @close="
                    () => {
                        showformdatamodel = false;
                    }
                "
            ></FormDataModel>

            <div slot="footer" class="dialog-footer">
                <el-button @click="showformdatamodel = false">返 回</el-button>
            </div>
        </el-dialog>

        <admin-select
            ref="transferUserSelect"
            @doSubmit="selectUsersToInput"
            :limit="1"
        ></admin-select>
        <el-dialog
            title="会议改期"
            :visible.sync="editDateDialogVisible"
            width="30%"
            :before-close="editDateHandleClose"
        >
            <el-form
                :model="editDateForm"
                :rules="editDateRules"
                ref="editDateForm"
                label-width="100px"
                class="demo-ruleForm"
            >
                <el-form-item label="会议日期" prop="hyrq">
                    <el-date-picker
                        v-model="editDateForm.hyrq"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="开始时间" prop="starttime">
                    <el-time-picker
                        format="HH:mm"
                        value-format="HH:mm"
                        v-model="editDateForm.starttime"
                        placeholder="请选择开始时间"
                    >
                    </el-time-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endtime">
                    <el-time-picker
                        v-model="editDateForm.endtime"
                        format="HH:mm"
                        value-format="HH:mm"
                        placeholder="请选择结束时间"
                    >
                    </el-time-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDateDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="editDateSubmit"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import GenerateForm from "@/components/jpgflow/DynamicForm/GenerateForm";
import AdminSelect from "@/components/AdminSelect/AdminSelect";
import FormDataModel from "../../form/data/list";
import { getToken } from "@/utils/auth";
import {
    listTable,
    getTable,
    delTable,
    addTable,
    editTable,
    advquerydelTable,
    advquerysaveTable,
    advquerylistTable,
    exportTable,
} from "@/api/bpm/table";
import QRCode from "qrcode";
import TabledataSvr from "@/api/bpm/tabledata";
import { listMenu } from "@/api/core/system/menu";
import BmpTask from "../task/task";
import { transferTask, datech } from "@/api/bpm/task";
import { FormxShowList } from "@/api/form/data";
import { runProcessList, delProcess } from "@/api/bpm/process";
import { listStuTurn } from "@/api/stu/stu_turn";
import { bpm } from "@/mixins/bpm.js";
import jfImport from "@/components/jfimport/jfimport";
export default {
    mixins: [bpm],
    components: {
        jfImport,
        BmpTask,
        GenerateForm,
        AdminSelect,
        FormDataModel,
    },
    name: "bpm_formdata_list",

    data() {
        return {
            importOpen: false,
            turn_list: [],
            formrowlabelinfo: {},
            rowid: null,
            propsMid: null,
            showformdatamodel: false,
            formdatamodeltitle: "扫码详情",
            propsqueryparam: {},
            selectrow: null,
            statusOptions: [
                { key: "-1", value: "挂起", type: "danger" },
                { key: "0", value: "草稿", type: "" },
                { key: "1", value: "待审批", type: "warning" },
                { key: "2", value: "审批通过", type: "success" },
                { key: "3", value: "撤回", type: "danger" },
                { key: "4", value: "驳回", type: "danger" },
                { key: "5", value: "终止", type: "danger" },
                { key: "6", value: "作废", type: "danger" },
            ],

            queryParams_formConfig: null,
            queryParams_formConfigOld: null,

            mustshowfield: ["starter_name", "process_status"],
            viewqrcodeinfourl: null,
            rowbtninfo: {
                114: [
                    {
                        label: "二维码",
                        name: "qrcode",
                    },
                ],
                107: [
                    {
                        label: "签到记录",
                        name: "showform",
                        mid: "47706575253509",
                    },
                    {
                        label: "回执情况",
                        name: "showform",
                        mid: "47708658307077",
                    },
                    { label: "改期", name: "edit_date" },
                ],
                10004: [
                    {
                        label: "扫码详情",
                        name: "Laobaoqrcodedetail",
                    },
                ],

                10003: [
                    {
                        label: "转派",
                        name: "tansfer",
                    },
                ],
                97: [
                    {
                        label: "转派",
                        name: "tansfer",
                    },
                ],
            },
            toolbtninfo: {
                10019: [
                    {
                        label: "批量导出",
                        name: "dacl",
                    },
                ],
                114: [
                    {
                        label: "下载二维码",
                        name: "downqrcode",
                    },
                ],
            },
            showtask: false,
            flowid: null,
            flowname: "",
            businessname: "table", //请勿改动
            exportfields: [],
            exportcheckAll: false,
            exportisIndeterminate: false,
            exportdialog: false,

            //编辑器配置
            ueConfig: {
                // 初始容器高度
                initialFrameHeight: 300,
                // 初始容器宽度
                initialFrameWidth: "100%",
                // 上传文件接口
                serverUrl: process.env.VUE_APP_BASE_API + "/file/ueditorupload",
                enableAutoSave: true,
                elementPathEnable: false,
                wordCount: false,
                UEDITOR_HOME_URL: "/ueditor/",
            },
            tableToolbar: {
                perfect: true,
                zoom: true,
                custom: true,
                refresh: {
                    query: this.handleQuery,
                },
                slots: {
                    buttons: "toolbar_buttons",
                },
            },

            // 列
            tableColumn: [],

            advqueryColumn: [
                {
                    field: "qfield",
                    title: "查询字段",
                    width: 180,
                    fixed: "left",
                    editRender: {
                        name: "select",
                        options: [
                            { value: "dd", label: "cxvs" },
                            { value: "zz", label: "cxvs" },
                        ],
                    },
                },
                {
                    field: "qopr",
                    title: "操作符",
                    width: 180,
                    fixed: "left",
                    editRender: { name: "select", options: [] },
                },
                {
                    field: "qvalue",
                    title: "值",
                    width: 180,
                    fixed: "left",
                    editRender: { name: "input" },
                },
                {
                    field: "qlogic",
                    title: "逻辑",
                    width: 180,
                    fixed: "left",
                    editRender: { name: "select", options: [] },
                },
                {
                    field: "",
                    title: "操作",
                    resizable: false,
                    width: 110,
                    fixed: "right",
                    align: "center",
                    slots: { default: "defaultadvqueryopr" },
                },
            ],
            advqueryColumn_tempfilter: [
                {
                    field: "tempname",
                    title: "模版名称",
                    width: 200,
                    fixed: "left",
                },
                {
                    field: "",
                    title: "操作",
                    resizable: false,
                    width: 180,
                    fixed: "right",
                    align: "center",
                    slots: { default: "defaultadvqueryopr_tempfilter" },
                },
            ],
            advqueryData_tempfilter: [],
            advqueryopen: false,
            advquery_tempsave: false,
            advqueryData: [],
            advqueryToolbar: {
                buttons: [
                    { code: "myInsert", name: "新增" },
                    { code: "dofilter", name: "使用此组合条件查询" },
                ],
            },
            upload: {
                headers: { Authorization: getToken() },
                url: process.env.VUE_APP_BASE_API + "/file/upload?public=1",
            },
            dialogVisible: false,

            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 表格数据
            dataList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 字典

            // 查询参数
            queryParams: {
                fieldval: {},
                sortinfo: { id: "desc" },
                pageNum: 1,
                pageSize: 10,
                querytype: {},
            },
            // 表单参数
            form: {},
            advquery_tempsaveform: {},
            advquery_tempsaverules: {
                tempname: [
                    {
                        required: true,
                        message: "模版名称不能为空",
                        trigger: "blur",
                    },
                ],
            },
            // 表单校验
            rules: {},
            userInfo: {},
            editDateForm: { startTime: "", starttime: "", endtime: "" },
            editDateRules: {
                hyrq: [
                    {
                        required: true,
                        message: "请选择会议日期",
                        trigger: "blur",
                    },
                ],
                starttime: [
                    {
                        required: true,
                        message: "请选择开始时间",
                        trigger: "blur",
                    },
                ],
                endtime: [
                    {
                        required: true,
                        message: "请选择结束时间",
                        trigger: "blur",
                    },
                ],
            },
            editDateDialogVisible: false,
        };
    },
    computed: {
        isShowAdd() {
            console.log(process.env.VUE_APP_TITLE, "VUE_APP_TITLE");
            if (process.env.VUE_APP_TITLE !== "安全生产管理系统") return true;
            return (
                this.flowid != "10012" &&
                this.flowid != "10013" &&
                this.flowid != "10014" &&
                this.flowid != "117"
            );
        },
    },
    created() {
        this.flowid = this.$route.params.flowid;

        let querys = this.$route.query;
        if (Object.keys(querys).length !== 0) {
            this.$nextTick(() => {
                setTimeout(() => {
                    for (let i in querys) {
                        this.$refs.qform.setData(querys[i], i);
                    }
                    this.handleQuery();
                }, 1000);
            });
        }

        TabledataSvr.tableInfo(this.flowid).then((rs) => {
            var rows = JSON.parse(rs.data.Rows);
            this.setqformConfig(JSON.parse(rs.data.ResourceData));
            this.settablecolum(rows, JSON.parse(rs.data.ResourceData));
        });

        listMenu({ auth: "/bpm/tabledata/list/" + this.flowid }).then((rs) => {
            if (rs.data.list.length > 0) {
                this.flowname = rs.data.list[0].title;
                this.settagtitle(this.flowname);
            }
        });
        listStuTurn({
            pageNum: 1,
            pageSize: 50,
        })
            .then((response) => {
                var dataList = response.data.list;

                for (var i in dataList) {
                    if (dataList[i].pid != 0) {
                        this.turn_list.push(dataList[i]);
                    }
                }

                //  var oplist = this.turn_list.map(rs=>{return {value:rs.no,label:rs.name}})
            })
            .catch(() => {});
    },
    methods: {
        editDateHandleClose() {
            this.editDateForm = {
                id: "",
                starttime: "",
                endtime: "",
                hyrq: "",
            };
            this.editDateDialogVisible = false;
        },
        editDateSubmit() {
            this.$refs["editDateForm"].validate((valid) => {
                if (valid) {
                    datech(this.editDateForm).then((res) => {
                        this.$message.success("会议改期成功");
                        this.editDateHandleClose();
                        this.getList();
                    });
                } else {
                    return false;
                }
            });
        },
        handleexport() {
            this.importOpen = true;
        },
        exportSubmit(fieldlist) {
            var colmap = {};
            for (var i in this.tableColumn) {
                colmap[this.tableColumn[i].field] = this.tableColumn[i].title;
            }
            var that = this;
            var tfa = [];
            for (var i in fieldlist) {
                var byname = "";
                if (fieldlist[i].byname != null) {
                    byname = fieldlist[i].byname;
                } else {
                    byname = colmap[fieldlist[i].field];
                }
                tfa.push(fieldlist[i].field + "=" + byname);
            }

            // return false

            var durl = TabledataSvr.TableDataDownloadUrl(
                this.flowid,
                this.queryParams,
                tfa
            );
            // let durl="/form/data/download/"+ this.mid

            try {
                this.downloadbyurl(durl, null, function (ers) {
                    if (ers.currentTarget.status != 200) {
                        that.msgError("导出错误");
                    }
                });
            } catch (error) {}
        },

        handleTodo(row) {
            let title = `${row.title || "审批"}【${this.flowname || ""}】`;
            if (row.node_name == "开始") {
                title = `编辑发起【${row.title || ""}】`;
            }
            this.$router.push({
                path: "/bpm/task/task",
                query: {
                    resourceId: row.resource_id,
                    id: row.id,
                    taskId: row.task_id,
                    title: title,
                },
            });
        },

        selectUsersToInput(users) {
            let userIds = users
                .map((user) => {
                    return user["id"];
                })
                .join(",");
            //获取选择的信息

            if (userIds == "") {
                return;
            }

            let taskIds = this.selectrow.task_id;
            transferTask({
                taskIds: taskIds,
                code: "transfer",
                comment: "转派",
                candidates: userIds,
                vars: "{}",
            }).then((response) => {
                this.msgSuccess("转派成功");
                this.getList();
            });
        },
        handleView(row) {
            let tparam = {
                id: row.id,
                flow_id: this.flowid,
                viewType: "run",
            };
            runProcessList(tparam).then((response) => {
                let dataList = response.data.list;
                this.$router.push({
                    path: "/bpm/task/view",
                    query: {
                        resourceId: row.resource_id,
                        id: row.id,
                        taskId: dataList.task_id,
                        title: this.flowname,
                    },
                });
            });
        },
        async getFormsrvDatabpm(mid) {
            var param = {
                fieldval: {},
                sortinfo: null,
                pageNum: 1,
                pageSize: 1000,
            };
            let res = await FormxShowList(mid, param);
            return res.data.list;
        },

        setqformConfig(res) {
            var tfields = [];
            res.processData = {};
            res.basicSetting = {};
            res.formData.fields.forEach((field) => {
                console.log("setqformConfig field", field);
                if (field.showpos && field.showpos.indexOf("查询") >= 0) {
                    field.span = 8;
                    field.required = false;
                    field.readonly = false;
                    field.disabled = false;
                    field.show = false;
                    field.defaultValue = undefined;
                    if (field.formsvr && field.formsvr.id) {
                        var formdatalist = this.getFormsrvDatabpm(
                            field.formsvr.id
                        );
                        formdatalist.then((rs) => {
                            let toption = [];
                            for (let ii in rs) {
                                let onerec = rs[ii];
                                var optionValue = field.formsvr.optionValue
                                    ? field.formsvr.optionValue
                                    : "id";
                                toption.push({
                                    label: onerec[field.formsvr.optionLabel],
                                    value: onerec[optionValue],
                                    originData: onerec,
                                });
                            }

                            field.options = toption;
                        });
                    }
                    if (field.type == "select" && field.vModel == "turn_no") {
                        field.options = this.turn_list.map((rs) => {
                            return { value: rs.no, label: rs.name };
                        });
                    }

                    tfields.push(field);
                }

                if (field.children) {
                    for (var ik in field.children) {
                        var tfield = field.children[ik];
                        if (
                            tfield.showpos &&
                            tfield.showpos.indexOf("查询") >= 0
                        ) {
                            tfield.span = 8;
                            tfield.required = false;
                            tfield.readonly = false;
                            tfield.disabled = false;
                            tfield.show = false;
                            tfield.defaultValue = undefined;
                            if (tfield.formsvr && tfield.formsvr.id) {
                                var formdatalist = this.getFormsrvDatabpm(
                                    tfield.formsvr.id
                                );
                                formdatalist.then((rs) => {
                                    let toption = [];
                                    for (let ii in rs) {
                                        let onerec = rs[ii];
                                        var optionValue = tfield.formsvr
                                            .optionValue
                                            ? tfield.formsvr.optionValue
                                            : "id";
                                        toption.push({
                                            label: onerec[
                                                tfield.formsvr.optionLabel
                                            ],
                                            value: onerec[optionValue],
                                            originData: onerec,
                                        });
                                    }

                                    tfield.options = toption;
                                });
                            }
                            if (
                                tfield.type == "select" &&
                                tfield.vModel == "turn_no"
                            ) {
                                tfield.options = this.turn_list.map((rs) => {
                                    return { value: rs.no, label: rs.name };
                                });
                            }

                            tfields.push(tfield);
                        }
                    }
                }
            });
            tfields.push({
                cmpType: "common",
                label: "发起时间",
                tag: "fc-date-duration",
                showDuration: false,
                tagIcon: "date-range",
                type: "datetimerange",
                defaultValue: null,
                span: 8,
                labelWidth: 0,
                style: {
                    width: "100%",
                },
                "range-separator": "至",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                disabled: false,
                clearable: true,
                required: false,
                format: "yyyy-MM-dd HH:mm",
                "value-format": "yyyy-MM-dd HH:mm",
                readonly: false,
                regList: [],
                changeTag: true,
                proCondition: true,
                asSummary: false,
                show: false,
                formId: 32,
                renderKey: 1718620220191645,
                layout: "colFormItem",
                vModel: "custom_ct",
                isApphide: false,
                dateRange: "",
            });

            res.formData.fields = tfields;
            res.formData.labelPosition = "right";
            //res.formData.labelWidth = "100";
            this.queryParams_formConfig = res.formData;
            this.queryParams_formConfigOld = JSON.stringify(res.formData);
        },
        startsuccess() {
            this.showtask = false;
        },
        handleToolBtnAction(item, row) {
            switch (item.name) {
                case "downqrcode":
                    this.$confirm("是否下载二维码？", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        this.msgSuccess("此功能正在开发中...");
                    });
                    break;
                case "dacl":
                    //档案材料导出
                    const queryParamsCopy = { ...this.queryParams };
                    queryParamsCopy.fieldval.process_status = 2;
                    // queryParamsCopy.fieldval.ty = "cldc";

                    var durl = TabledataSvr.TableDataDownloadUrl(
                        this.flowid,
                        queryParamsCopy,
                        "id",
                        "cldc"
                    );
                    // let durl="/form/data/download/"+ this.mid

                    try {
                        this.downloadbyurl(durl, null, function (ers) {
                            if (ers.currentTarget.status != 200) {
                                that.msgError("导出错误");
                            }
                        });
                    } catch (error) {}
            }
        },
        handleBtnAction(item, row) {
            this.selectrow = row;
            switch (item.name) {
                case "qrcode":
                    let text =
                        location.origin +
                        "/sbxx/qrcode/" +
                        row.id +
                        "/" +
                        this.flowid;
                    this.getQRcode(text);
                    break;
                case "tansfer":
                    if (row.process_status != 1) {
                        this.msgError("只能转派审核中的流程");

                        return;
                    }

                    this.$refs.transferUserSelect.init();

                    break;
                case "Laobaoqrcodedetail":
                    TabledataSvr.Laobaoqrcodedetail({
                        flowid: 10004,
                        id: row.id,
                    })
                        .then((_) => {
                            this.propsqueryparam = { lyjhid: row.id };

                            this.propsMid = "46969230768133";
                            this.showformdatamodel = true;
                            this.formdatamodeltitle = "扫码详情";
                        })
                        .catch();

                    break;
                case "showform":
                    this.propsqueryparam = { hy_flowInstId: row.id };

                    this.propsMid = item.mid;
                    this.showformdatamodel = true;
                    this.formdatamodeltitle = item.label;
                    break;
                case "edit_date":
                    if (
                        row.starter_id != this.$store.state.user.id ||
                        row.process_status != 1
                    ) {
                        this.msgError("只能修改自己发起的未审批流程");
                        return;
                    }
                    this.editDateForm = {
                        id: row.id,
                        starttime: row.start_time,
                        endtime: row.end_time,
                        hyrq: row.hyrq,
                    };
                    this.editDateDialogVisible = true;
                    break;
            }
        },
        getQRcode(text) {
            QRCode.toDataURL(
                text,
                { errorCorrectionLevel: "L", margin: 2, width: 512 },
                (err, url) => {
                    if (err) throw err;
                    this.viewqrcodeinfourl = url;
                    // this.QRImgUrl = url;
                    // window.open(url);
                }
            );
        },

        getallshowfield(fields) {
            let tar = [];
            for (const item of fields) {
                if (
                    item.showpos &&
                    item.rowType !== "layout" &&
                    item.showpos.indexOf("列表") >= 0
                ) {
                    tar.push(item);
                }
                if (item.children && item.rowType === "layout") {
                    // 递归调用自身处理子节点并合并结果
                    tar = tar.concat(this.getallshowfield(item.children));
                }
            }
            return tar;
        },
        settablecolum(data, recdata) {
            let tableColumn = [{ type: "checkbox", width: 60, fixed: "left" }];
            let showposfield = [];
            let fileconf = this.getallshowfield(recdata.formData.fields);
            fileconf.forEach((field) => {
                showposfield.push(field.vModel);
                // if (field.showpos && field.showpos.indexOf("列表") >= 0) {

                //     // fileconf.push(field);
                // }
            });

            this.mustshowfield.forEach((field) => {
                showposfield.push(field);
            });

            //   return;

            for (let findex in showposfield) {
                let onefield = showposfield[findex];
                if (true) {
                    let times = ["create_time", "update_time", "delete_time"];

                    var formatter = "";
                    var isdatefield =
                        times.findIndex((o) => o == onefield) != -1;
                    if (isdatefield) {
                        formatter = "formatDate";
                    }
                    let tcolinfo = {
                        field: onefield,
                        title:
                            (fileconf[findex] && fileconf[findex].label) || "",
                        minWidth: 80,
                        formatter: "",
                    };
                    if (
                        fileconf[findex] != null &&
                        fileconf[findex].type == "post"
                    ) {
                        formatter = this.postFormat;
                    }

                    if (
                        fileconf[findex] != null &&
                        fileconf[findex].type == "dict" &&
                        fileconf[findex].dictType != null
                    ) {
                        formatter = this.dictFormat;
                        tcolinfo.dictType = fileconf[findex].dictType;
                    }

                    if (
                        fileconf[findex] != null &&
                        fileconf[findex].type == "select"
                    ) {
                        formatter = this.selectFormat;
                        tcolinfo.optiondata = fileconf[findex].options;
                        if (onefield == "turn_no") {
                            tcolinfo.optiondata = this.turn_list.map((rs) => {
                                return { value: rs.no, label: rs.name };
                            });
                        }
                    }

                    if (
                        fileconf[findex] != null &&
                        fileconf[findex].type == "datetimerange"
                    ) {
                        formatter = this.datetimerangeFormat;
                        tcolinfo.width = 260;
                        tcolinfo.formconf = fileconf[findex];
                    }

                    if (
                        fileconf[findex] != null &&
                        fileconf[findex].type == "form"
                    ) {
                        formatter = this.jsonFormat;
                        tcolinfo.width = 600;
                        tcolinfo.formconf = fileconf[findex];
                    }
                    if (
                        fileconf[findex] != null &&
                        fileconf[findex].formsvr != null &&
                        fileconf[findex].formsvr.id != null
                    ) {
                        formatter = this.formsvrFormat;
                        tcolinfo.formsvr = fileconf[findex].formsvr;
                    }

                    tcolinfo.formatter = formatter;

                    if (onefield == "process_status") {
                        tcolinfo.slots = {
                            default: "flowstatus",
                        };
                        tcolinfo.title = "审批状态";
                    }
                    if (onefield == "turn_no") {
                        tcolinfo.slots = {
                            default: "turn_no",
                        };
                        tcolinfo.title = "所属学期";
                    }

                    if (onefield == "starter_name") {
                        tcolinfo.title = "发起人姓名";
                    }

                    if (onefield == "v_d") {
                        tcolinfo.slots = {
                            default: "html",
                        };
                    }
                    // if (this.flowid == "155" && onefield === "rate31") {
                    //     tcolinfo.formatter = ({ row }) => {
                    //         return Number(row.rate31) > 0 ? row.rate31 : "\\";
                    //     };
                    // }
                    tableColumn.push(tcolinfo);
                }
            }

            tableColumn.push({
                field: "",
                title: "操作",
                width: this.flowid == 107 ? 350 : 230,
                fixed: "right",
                align: "center",
                slots: { default: "defaultopr" },
            });
            this.tableColumn = tableColumn;

            for (let i = 0; i < this.tableColumn.length; i++) {
                const col = this.tableColumn[i];
                if (col.dictType) {
                    this.getDicts(col.dictType).then((response) => {
                        if (response.code == 0) {
                            col.dictData = response.data;
                            this.dataList = [].concat(this.dataList);
                        }
                    });
                }

                if (col.formsvr) {
                    var formdatalist = this.getFormsrvDatabpm(col.formsvr.id);

                    formdatalist.then((rs) => {
                        col.formData = rs;
                        this.dataList = [].concat(this.dataList);
                    });
                } //if
            } //for

            this.getList();
        },
        datetimerangeFormat(e, p) {
            try {
                var jsonv = JSON.parse(e.cellValue);
                if (Array.isArray(jsonv)) {
                    return jsonv.join(" 至 ");
                } else {
                    return e.cellValue;
                }
            } catch (error) {
                return e.cellValue;
            }
            return;
        },
        jsonFormat(e, p) {
            var columninfo = this.tableColumn[e.columnIndex];
            if (this.formrowlabelinfo[columninfo.field] == null) {
                this.formrowlabelinfo[columninfo.field] = {};
                for (var k in columninfo.formconf.children) {
                    var onecol = columninfo.formconf.children[k];
                    this.formrowlabelinfo[columninfo.field][onecol.vModel] =
                        onecol.label;
                }
            }

            try {
                var jsonv = JSON.parse(e.cellValue);
                var tar = [];
                if (Array.isArray(jsonv)) {
                    for (let i = 0; i < jsonv.length; i++) {
                        var item = jsonv[i];
                        for (let j in item) {
                            if (j == "id" || j == "ID") {
                                continue;
                            }
                            var kn = this.formrowlabelinfo[columninfo.field][j];
                            kn != null && tar.push(kn + ":" + item[j]);
                        }
                    }
                }
                return tar.join(",");
            } catch (error) {
                return e.cellValue;
            }
        },
        postFormat(e) {
            try {
                var tjson = JSON.parse(e.cellValue);
                console.log("tjson", tjson);
                var ta = [];
                for (var k in tjson) {
                    ta.push(tjson[k].name);
                }
                return ta.join(",");
            } catch (error) {
                return e.cellValue;
            }
        },
        dictFormat(e) {
            const col = this.tableColumn[e.columnIndex];
            if (col.dictData) {
                const values = e.cellValue ? e.cellValue.split(",") : [];
                const labels = [];
                for (let i = 0; i < values.length; i++) {
                    const v = values[i];
                    for (let j = 0; j < col.dictData.values.length; j++) {
                        const item = col.dictData.values[j];
                        if (v == item.key) {
                            labels.push(item.value);
                            break;
                        }
                    }
                }
                return labels.join(",");
            }
            return e.cellValue;
        },
        selectFormat(e) {
            const col = this.tableColumn[e.columnIndex];
            var val = e.cellValue;
            if (col.optiondata) {
                const values = val ? val.split(",") : [];
                const labels = [];
                for (let i = 0; i < values.length; i++) {
                    const v = values[i];
                    for (let j = 0; j < col.optiondata.length; j++) {
                        const item = col.optiondata[j];
                        if (v == item.value) {
                            labels.push(item.label);
                            break;
                        }
                    }
                }
                return labels.join(",");
            }
            return e.cellValue;
        },
        formsvrFormat(e) {
            const col = this.tableColumn[e.columnIndex];
            if (col.formData && col.formsvr) {
                var optionValue = col.formsvr.optionValue
                    ? col.formsvr.optionValue
                    : "id";

                var tar = [];
                for (let ii in col.formData) {
                    let onerec = col.formData[ii];

                    if (this.isjson(e.cellValue)) {
                        var vallist = JSON.parse(e.cellValue);
                        if (Array.isArray(vallist)) {
                            for (let ik in vallist) {
                                if (vallist[ik] == onerec[optionValue]) {
                                    tar.push(onerec[col.formsvr.optionLabel]);
                                }
                            }
                        } else if (vallist == onerec[optionValue]) {
                            tar.push(onerec[col.formsvr.optionLabel]);
                        }
                    }
                }
                return tar.join(",");
            }
            return e.cellValue;
        },

        settagtitle(title) {
            this.$route.meta.title = title;
            document.title = title;
            for (var i in this.$router.app.$store.state.tabsBar.visitedRoutes) {
                var onetag =
                    this.$router.app.$store.state.tabsBar.visitedRoutes[i];
                if (onetag.path == this.$route.path) {
                    this.$router.app.$store.state.tabsBar.visitedRoutes[
                        i
                    ].title = title;
                    return true;
                }
            }
            // this.$router.app.$store.state.tagsView.visitedViews[1].title="sdfsdfs"
        },

        //表单上传字段成功处理
        handleImportSuccess(response, file, fileList) {
            this.upload.open = false;
            this.upload.isUploading = false;
            var field = response.data.return_field;

            this.form[field] = this.form[field] || [];
            this.form[field].push(response.data.url);
            this[field + "_fileList"].push({ url: response.data.url });
        },
        handleUpload() {},
        /** 打开导入表弹窗 */
        openImportTable() {
            this.$refs.import.show();
        },
        handleExport() {
            if (this.total > 0) {
                this.exportdialog = true;
            } else {
                this.msgError("暂无数据可导出!");
            }
        },
        doExport() {
            const queryParams = this.queryParams;
            this.$confirm("是否确认导出?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(function () {
                    return exportTable(
                        queryParams,
                        this.exportfields,
                        this.tableColumn
                    );
                })
                .then((response) => {
                    this.download(response.file);
                })
                .catch(function () {});
        },
        handleexportCheckAllChange(val) {
            this.exportfields = val
                ? this.tableColumn.map((item) => {
                      return item.field;
                  })
                : [];
            this.exportisIndeterminate = false;
        },
        //删除查询模版
        handleadvqueryDeltpl(row) {
            var ids = row.id;
            this.$confirm("是否确认删除?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(function () {
                    advquerydelTable(ids)
                        .then(() => {
                            const $grid = this.$refs.xAdvqueryGrid_tempfilter;
                            $grid.remove(row);
                        })
                        .then(() => {
                            this.msgSuccess("删除成功");
                        });
                })
                .then(() => {
                    this.msgSuccess("删除成功");
                })
                .catch(function () {});
        },
        //打开高级查询
        handleAdvquery() {
            advquerylistTable(this.businessname).then((response) => {
                this.advqueryData_tempfilter = response.data.list;
                this.advqueryopen = true;
            });
        },
        //保存条件
        advquery_save() {
            const $grid = this.$refs.xAdvqueryGrid;
            var alldata = $grid.getTableData();
            if (alldata.fullData.length == 0) {
                return false;
            }

            var opstr = {};
            var filteroptview = [];
            var Qlogicar = this.defaultQlogic();
            var queryParams = {};
            var fields = {},
                Qlogic = {};

            for (var i in this.tableColumn) {
                var col = this.tableColumn[i];
                if (col.field != null && col.field != "") {
                    fields[col.field] = col.title;
                }
            }

            for (var i in Qlogicar) {
                var lgc = Qlogicar[i];
                Qlogic[lgc.value] = lgc.label;
            }

            for (var i in alldata.fullData) {
                var onerow = alldata.fullData[i];
                queryParams[onerow.qfield] = onerow.qvalue;
                opstr[onerow.qfield] = onerow.qopr;
                filteroptview.push(
                    fields[onerow.qfield] +
                        " " +
                        Qlogic[onerow.qopr] +
                        "" +
                        onerow.qvalue
                );
            }

            queryParams.opstr = opstr;
            this.advquery_tempsaveform["businessname"] = this.businessname;
            this.advquery_tempsaveform["filteropt"] =
                JSON.stringify(queryParams);
            this.advquery_tempsaveform["filteroptview"] =
                filteroptview.join(";");

            this.$refs["advquery_tempsaveform"].validate((valid) => {
                if (valid) {
                    advquerysaveTable(this.advquery_tempsaveform).then(
                        (response) => {
                            if (response.code === 0) {
                                this.msgSuccess("保存成功");
                                this.advquery_tempsave = false;
                                this.handleAdvquery();
                            }
                        }
                    );
                }
            });
        },

        //应用查询模版
        handleadvqueryApplytpl(row) {
            var Filteropt = JSON.parse(row.filteropt);

            Filteropt["pageNum"] = 1;
            Filteropt["pageSize"] = 10;
            this.queryParams = Filteropt;
            this.advqueryopen = false;
            setTimeout(() => {
                this.getList();
            }, 300);
        },
        //删除临时条件
        handleadvqueryDeleted(row) {
            const $grid = this.$refs.xAdvqueryGrid;

            this.$confirm("是否确认删除?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(function () {
                    $grid.remove(row);
                })
                .then(() => {
                    this.msgSuccess("删除成功");
                })
                .catch(function () {});
        },
        advqtoolbarButtonClickEvent({ code }) {
            const $grid = this.$refs.xAdvqueryGrid;
            switch (code) {
                case "myInsert":
                    var row = $grid.insert({
                        qfield: "",
                        qopr: "=",
                        qlogic: "AND",
                    });

                    $grid.setActiveRow($grid.getData(0));
                    break;

                case "dosavefilter":
                    var alldata = $grid.getTableData();
                    if (alldata.fullData.length == 0) {
                        return false;
                    }
                    this.advquery_tempsave = true;
                    break;
                case "dofilter":
                    var alldata = $grid.getTableData();
                    if (alldata.fullData.length == 0) {
                        return false;
                    }

                    var opstr = {};

                    var queryParams = {
                        pageNum: 1,
                        pageSize: 10,
                        opstr: {},
                    };

                    for (var i in alldata.fullData) {
                        var onerow = alldata.fullData[i];
                        queryParams[onerow.qfield] = onerow.qvalue;
                        opstr[onerow.qfield] = onerow.qopr;
                    }

                    queryParams.opstr = opstr;
                    this.queryParams = queryParams;
                    this.advqueryopen = false;
                    setTimeout(() => {
                        this.getList();
                    }, 300);
                    break;
            }
        },

        checkboxChangeEvent({ records }) {
            this.ids = records.map((item) => item.id);
            this.single = records.length != 1;
            this.multiple = !records.length;
        },

        handleSizeChange({ currentPage, pageSize }) {
            this.queryParams.pageNum = currentPage;
            if (this.queryParams.pageSize == pageSize) {
                this.getList();
            } else {
                this.queryParams.pageSize = pageSize;
                this.handleQuery();
            }
        },

        /** 查询列表 */
        getList() {
            this.loading = true;
            if (this.flowid == 10006) {
                this.queryParams.sortinfo = {
                    r_type: "desc",
                    name: "asc",
                    id: "desc",
                };
            }
            // this.queryParams.fieldval["process_status"]="1,2"
            // this.queryParams.querytype["process_status"]="in"
            TabledataSvr.tableDataList(this.queryParams, this.flowid)
                .then((response) => {
                    let datalist = JSON.parse(response.data.rows);
                    this.dataList = this.formatdata(datalist.rows);
                    this.total = datalist.total;
                    this.loading = false;
                })
                .catch((_) => {
                    this.loading = false;
                });
        },

        // $comment字典翻译

        // 取消按钮
        cancel() {
            this.open = false;
            this.advqueryopen = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                name: undefined,
                table_name: undefined,
                table_comment: undefined,
            };
            this.resetForm("form");
        },
        dateStringToTimestampSeconds(dateString) {
            // 替换空格为 'T' 并添加 'Z'（按 UTC 解析，避免时区问题）
            //   const isoString = dateString.replace(" ", "T") + "Z";
            const date = new Date(dateString);

            if (isNaN(date.getTime())) {
                throw new Error("Invalid date string");
            }

            // 返回秒级时间戳（除以 1000 并取整）
            return Math.floor(date.getTime() / 1000);
        },
        /** 搜索按钮操作 */
        handleQuery() {
            var qdatapri = this.$refs.qform.getData(false);
            qdatapri.then((qdata) => {
                this.queryParams.fieldval = {};
                for (let qfield in qdata) {
                    let qvalue = qdata[qfield];

                    if (qfield == "custom_ct") {
                        qfield = "date23";
                        // console.log("qfield qvalue", qfield, qvalue);
                        // var dt1 = this.dateStringToTimestampSeconds(
                        //     qvalue[0] + ":00"
                        // );
                        // var dt2 = this.dateStringToTimestampSeconds(
                        //     qvalue[1] + ":00"
                        // );
                        // console.log("dt1 dt2", dt1, dt2);
                        this.queryParams.fieldval[qfield] = [qvalue[0], qvalue[1]];
                        this.queryParams.querytype[qfield] = "between";
                    } else if (
                        typeof qvalue === "string" &&
                        qvalue &&
                        qvalue != ""
                    ) {
                        this.queryParams.fieldval[qfield] = qvalue;
                        this.queryParams.querytype[qfield] = "like";
                        if (qfield.indexOf("rate") != -1) {
                            this.queryParams.querytype[qfield] = "=";
                        }
                        // && qvalue * 1 === 0
                    } else if (qvalue && qvalue != "") {
                        this.queryParams.fieldval[qfield] = qvalue;
                    } else if (typeof qvalue === "number" && qvalue * 1 === 0) {
                        this.queryParams.fieldval[qfield] = qvalue;
                    }
                }

                this.queryParams.pageNum = 1;
                this.getList();
            });

            // this.queryParams.pageNum = 1;
            // this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            // this.resetForm("queryForm");
            this.queryParams_formConfig = null;
            this.$nextTick(() => {
                this.queryParams_formConfig = JSON.parse(
                    this.queryParams_formConfigOld
                );
            });

            this.queryParams.pageNum = 1;
            this.queryParams.fieldval = {};
            this.getList();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map((item) => item.id);
            this.single = selection.length !== 1;
            this.multiple = !selection.length;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.$router.push({
                path: "/bpm/task/task",
                query: {
                    /* resourceId: row.resource_id,*/
                    /*time: this.XEUtils.now(),*/
                    flowId: this.flowid,
                    title: `发起流程【${this.flowname}】`,
                },
            });

            // this.showtask = true;
            // this.$nextTick(() => {
            //     this.$refs["BmpTask"].init();
            // });

            //   this.reset();
            //   this.open = true;
            //   this.title = "添加";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const id = row.id || this.ids;
            getTable(id).then((response) => {
                this.form = response.data.data;

                this.open = true;
                this.title = "修改";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    if (this.form.id != null) {
                        editTable(this.form).then((response) => {
                            if (response.code === 0) {
                                this.msgSuccess("修改成功");
                                this.open = false;
                                setTimeout(() => {
                                    this.getList();
                                }, 300);
                            }
                        });
                    } else {
                        addTable(this.form).then((response) => {
                            if (response.code === 0) {
                                this.msgSuccess("新增成功");
                                this.open = false;
                                setTimeout(() => {
                                    this.getList();
                                }, 300);
                            }
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const ids = row.id || (this.ids ? this.ids.join(",") : "");
            let title = "警告";
            if (row.id) {
                title = "警告:【" + row.id + "】";
            }
            this.$prompt("作废原因", title, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPlaceholder: "请输入作废原因",
                type: "warning",
            })
                .then(({ value }) => {
                    return delProcess(ids, value);
                })
                .then(() => {
                    this.getList();
                    this.msgSuccess("作废成功");
                })
                .catch(function () {});
        },
    }, //methods结束
};
</script>
